import React from 'react'
import Backdrop from '@material-ui/core/Backdrop'
import CircularProgress from '@material-ui/core/CircularProgress'
import { makeStyles } from '@material-ui/core/styles'
import { useSelector } from 'react-redux'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#7c606b',
  },
  circularProgress: {
    color: '#860d56',
  }
}))

export const Loading = () => {
  const classes = useStyles()
  const loading = useSelector((state) => state.app.loading)

  return (
    <div>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress className={classes.circularProgress} />
      </Backdrop>
    </div>
  )
}
